import { DataSearch } from "../Components/SearchBox/SearchBox"
import { Funcoes } from "./Funcoes"
import { Cidade, CidadeEstadoAttributes, DadosCNPJ, error99, Estado, RetAPI } from "./Types"
import { Api } from "./api"

export const UtilServices = {

    ConsultarCNPJ: async (cnpj: string): Promise<DadosCNPJ> => {
        let dadosCNPJ: DadosCNPJ = {
            abertura: "",
            bairro: "",
            cep: "",
            cnpj: "",
            logradouro: "",
            municipio: "",
            razao: "",
            id_cidade: 0,
            id_uf: 0,
            registro: false
        }
        cnpj = Funcoes.onlyNumber(cnpj)
        const resp = await Api('Util/ConsultaCNPJ/' + cnpj + '?tipo=P', 'get')

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            dadosCNPJ.abertura = resp.data.abertura
            dadosCNPJ.bairro = resp.data.bairro
            dadosCNPJ.cep = resp.data.cep
            dadosCNPJ.cnpj = resp.data.cnpj
            dadosCNPJ.compl = resp.data.complemento || ''
            dadosCNPJ.email = resp.data.email || ''
            dadosCNPJ.fantasia = resp.data.fantasia || ''
            dadosCNPJ.logradouro = resp.data.logradouro || ''
            dadosCNPJ.municipio = resp.data.municipio || ''
            dadosCNPJ.razao = resp.data.nome
            dadosCNPJ.numero = resp.data.numero || ''
            dadosCNPJ.uf = resp.data.uf || ''
            dadosCNPJ.id_cidade = resp.data.id_cidade
            dadosCNPJ.id_uf = resp.data.id_uf
            dadosCNPJ.registro = resp.data.registro
        }
        
        return dadosCNPJ
    },

    GetCidadeEstado: async (): Promise<RetAPI> => {

        const resp = await Api('Util/getCidades', 'get')
        const attributes: CidadeEstadoAttributes = {
            estados: [],
            cidades: [],
        }

        if (resp.data) {

            let estados: Estado[] = []
            let cidades: Cidade[] = []

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.estados) {
                    estados = resp.data.estados.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.nome,
                            sigla: item.sigla,
                            codIBGE: item.codIBGE,
                        }
                    })
                    attributes.estados = estados
                }

                if (resp.data.cidades) {
                    cidades = resp.data.cidades.map((item: any) => {
                        return {
                            id: item.codigo,
                            description: item.nome,
                            uf: item.uf,
                            codIBGE: item.codigo,
                        }
                    })
                    attributes.cidades = cidades
                }

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },
    
    GetBancos: async (): Promise<RetAPI> => {

        const resp = await Api('Banco/List  ', 'get')
        const bancos: DataSearch[] = []

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                data: bancos
            }
        }

        if (resp.data.error && resp.data.error === '0') {

            if (resp.data.bancos) {
                await resp.data.bancos.map((item: any) => {
                    bancos.push({
                        id: item.cod_banco,
                        description: item.nome,
                    })
                })
            }
        }

        return {
            error: false,
            data: bancos
        }
    }
    
}